var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.avatarWrapper},[_c('BaseAvatar',{attrs:{"url":_vm.url,"size":125,"max-width-view-width":25}}),_c('div',{class:[
      _vm.$style.avatarEdit,
      _vm.$style[("avatarEditTheme" + _vm.theme)]
    ],on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{attrs:{"icon":"pencil-alt"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }